import { Checkbox } from '@mui/material';
import styled from 'styled-components';
import { SummaryContainer } from '../containers';
import COLORS from '../../colors';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { useEffect, useState } from 'react';
import { getMonthsInRange } from '../../services/date';
import { mapPascalMonthToLowercaseMonth } from '../../util';
import { MONTH_PASCAL } from '../../constants';

interface StyledItemProps {
  isHighlighted?: boolean;
}

const StyledColumns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;
`;

const Column = styled.div`
  flex: 1;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

const StyledTableHeading = styled.p`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13.33px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${COLORS.NEUTRAL_500};
  padding: 0 12px;
`;

const StyledTableHeadingSmall = styled.p`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 13.33px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${COLORS.NEUTRAL_500};
  padding: 0 12px;
  max-width: 60px;
`;

const StyledItem = styled.div<StyledItemProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${COLORS.NEUTRAL_200};
  padding: 12px;
  background-color: ${(props) =>
    props.isHighlighted ? COLORS.NEUTRAL_925 : 'transparent'};
  border-radius: 8px;
`;

const StyledCheckbox = styled(Checkbox)`
  color: ${COLORS.NEUTRAL_400} !important;
  padding: 0 !important;
`;

const DayStrat = () => {
  const { demographic } = useAppSelector((state: RootState) => state.detail);

  const monthData = useAppSelector((state: RootState) => state.calculated);

  const { startDate, endDate } = useAppSelector(
    (state: RootState) => state.detail.campaignLength
  );

  const [months, setMonths] = useState<string[]>([]);

  useEffect(() => {
    if (!startDate || !endDate) {
      return;
    }

    const monthsInRange = getMonthsInRange(
      new Date(startDate),
      new Date(endDate)
    );
    setMonths(monthsInRange);
  }, [startDate, endDate]);

  return (
    <SummaryContainer title="Day Strat">
      <StyledColumns>
        <Column>
          <Row>
            <StyledTableHeadingSmall></StyledTableHeadingSmall>
            <StyledTableHeading>Sunday</StyledTableHeading>
            <StyledTableHeading>Monday</StyledTableHeading>
            <StyledTableHeading>Tuesday</StyledTableHeading>
            <StyledTableHeading>Wednesday</StyledTableHeading>
            <StyledTableHeading>Thursday</StyledTableHeading>
            <StyledTableHeading>Friday</StyledTableHeading>
            <StyledTableHeading>Saturday</StyledTableHeading>
          </Row>
          {months.map((month) => {
            if (!month || !demographic) {
              return;
            }

            const selectedMonth = mapPascalMonthToLowercaseMonth(
              month as MONTH_PASCAL
            );

            return (
              <Row>
                <StyledTableHeadingSmall>{month}</StyledTableHeadingSmall>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.sunday == 0}
                    disabled
                  />
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.monday == 0}
                    disabled
                  />
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.tuesday == 0}
                    disabled
                  />{' '}
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.wednesday == 0}
                    disabled
                  />{' '}
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.thursday == 0}
                    disabled
                  />{' '}
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.friday == 0}
                    disabled
                  />{' '}
                </StyledItem>
                <StyledItem>
                  <StyledCheckbox
                    checked={monthData[selectedMonth].days.saturday == 0}
                    disabled
                  />{' '}
                </StyledItem>
              </Row>
            );
          })}
        </Column>
      </StyledColumns>
    </SummaryContainer>
  );
};

export default DayStrat;
